

export default {
  name: "img2",
  mounted() { },
  created() {
    this.randomKey = this.newImageKey();
  },
  activated: function (el) {
  },
  deactivated() {
  },
  methods: {
    onError(){
      this.$refs.img.classList.add('_error');
    },
  },
  data() {
    return {
      randomKey: ''
    };
  },
};
